var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-speak-text",on:{"click":_vm.toggleSpeakText}},[(_vm.paused || !_vm.speaking)?_c('Icon',{attrs:{"speaker":""}}):_c('Icon',{attrs:{"pause":""}}),(_vm.showLabel)?_c('div',{staticClass:"v-speak-text__label"},[_vm._v(" "+_vm._s(_vm.$t("Read out", "components.speak-text.readout"))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }